import React from 'react';
import '../../styles/ProfessorDashboard.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  itemName?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  onPageChange,
  itemName = '개'
}) => {
  // 페이지 변경 핸들러
  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  // 페이지가 1개뿐이면 페이지네이션 표시 안 함
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-container">
      {/* 이전 버튼 */}
      <button
        className="pagination-nav"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        aria-label="이전 페이지"
      >
        ◀
      </button>

      {/* 페이지 번호들 */}
      {[...Array(totalPages)].map((_, index) => {
        const pageNum = index + 1;
        return (
          <button
            key={pageNum}
            className={`pagination-number ${pageNum === currentPage ? 'active' : ''}`}
            onClick={() => handlePageChange(pageNum)}
            aria-label={`${pageNum} 페이지`}
            aria-current={pageNum === currentPage ? 'page' : undefined}
          >
            {pageNum}
          </button>
        );
      })}

      {/* 페이지 정보 (숨김 처리됨) */}
      <div
        className="pagination-info"
        aria-label={`${currentPage} / ${totalPages} 페이지 (총 ${totalItems}${itemName})`}
      >
        {currentPage} / {totalPages} 페이지 (총 {totalItems}{itemName})
      </div>

      {/* 다음 버튼 */}
      <button
        className="pagination-nav"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        aria-label="다음 페이지"
      >
        ▶
      </button>
    </div>
  );
};

export default Pagination;
